export const ORDER_ASIDE_SHEET_CONTENT_CLASS =
  'w-full max-w-[calc(100vw-0.75rem)] overflow-y-auto px-0 pb-0 sm:w-[42rem] sm:max-w-[calc(100vw-1rem)] md:max-w-[42rem]'

export const ORDER_ASIDE_FORM_SURFACE_CLASS =
  'border-t border-border/60 bg-transparent pt-4 sm:pt-5 [&_[data-slot=input]]:bg-card [&_[data-slot=textarea]]:bg-card [&_[data-slot=select-trigger]]:bg-card [&_button[id="date"]]:bg-card dark:[&_[data-slot=input]]:bg-input/30 dark:[&_[data-slot=textarea]]:bg-input/30 dark:[&_[data-slot=select-trigger]]:bg-input/30 dark:[&_button[id="date"]]:bg-input/30'

export const ORDER_ASIDE_SUBTLE_SURFACE_CLASS = 'rounded-xl border border-border bg-elevated'

export const ORDER_ASIDE_RAISED_SURFACE_CLASS = 'rounded-xl border border-border bg-card'

export const ORDER_ASIDE_INFO_SURFACE_CLASS =
  'rounded-xl border border-status-info-border bg-status-info-background'

export const ORDER_ASIDE_WARNING_SURFACE_CLASS =
  'rounded-xl border border-status-warning-border bg-status-warning-background'
